module.exports = __webpack_public_path__ + "img/44.115d2503.jpg";